import type { VoidFunctionComponent } from 'react';

import { emptyConclusionData } from '../../../../../../shared/types/licenses';
import useGetGlobalDependency from '../../../../../hooks/api/dependencies/useGetGlobalDependency';
import DependencyLicenses from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/DependencyLicenses';
import type {
  LicenseTabScope,
} from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/types';

type GlobalLicensesTableProps = {
  dependencyRevisionLocator: string;
};

export const GlobalLicensesTable: VoidFunctionComponent<GlobalLicensesTableProps> = ({
  dependencyRevisionLocator,
}) => {
  const { data, isLoading } = useGetGlobalDependency(dependencyRevisionLocator, true);

  const dependency = data?.dependency;

  const globalDependencyConcludedLicenseCount = dependency?.rootProjects.reduce(
    (acc, project) => {
      if (project.conclusions) {
        project.conclusions.scoped.licenses.forEach(license => {
          acc[license] = (acc[license] || 0) + 1;
        });
      }
      return acc;
    },
    {} as Record<string, number>,
  );

  const licenseTabScope: LicenseTabScope = {
    dependencyRevisionLocator,
    type: 'global',
    concludedLicenseCountMap: globalDependencyConcludedLicenseCount || {},
  };

  return (
    <DependencyLicenses
      issues={dependency?.issues || []}
      licenseGroups={dependency?.licenseGroups || []}
      concludedLicenses={dependency?.conclusions || emptyConclusionData}
      scope={licenseTabScope}
      isLoading={isLoading}
      dependency={{
        title: dependency?.title || '',
        version: dependency?.version || '',
        locator: dependency?.locator || '',
      }}
    />
  );
};
